(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["sw-abo-ritual"] && !Shopify.designMode) return;
  try {
    
(()=>{function init(){const root=document.querySelector('#sw-abo-page');if(!root||root.dataset.bound)return;root.dataset.bound='true';if('IntersectionObserver' in window){const observer=new IntersectionObserver(entries=>root.classList.toggle('ar-sticky-visible',!entries[0].isIntersecting),{threshold:0});observer.observe(root.querySelector('.ar-hero'));}let busy=false;root.querySelectorAll('.ar-buy').forEach(form=>form.addEventListener('submit',async e=>{e.preventDefault();e.stopImmediatePropagation();if(busy)return;busy=true;const button=form.querySelector('button'),label=button.innerHTML,error=form.querySelector('.ar-error');error.hidden=true;root.querySelectorAll('.ar-buy button').forEach(b=>{b.dataset.wasDisabled=b.disabled?'1':'0';b.disabled=true});button.textContent=root.querySelector('[data-checkout-loading]').textContent;try{const base=window.Shopify?.routes?.root||'/';const id=Number(form.elements.id.value),plan=Number(form.elements.selling_plan.value);if(!id||!plan)throw new Error();const data=await new Promise((resolve,reject)=>{const xhr=new XMLHttpRequest();xhr.open('POST',base+'cart/add.js');xhr.setRequestHeader('Content-Type','application/json');xhr.setRequestHeader('Accept','application/json');xhr.timeout=20000;xhr.onload=()=>{try{const payload=JSON.parse(xhr.responseText);if(xhr.status>=200&&xhr.status<300)resolve(payload);else reject(new Error());}catch(e){reject(e)}};xhr.onerror=xhr.ontimeout=()=>reject(new Error());xhr.send(JSON.stringify({items:[{id,quantity:1,selling_plan:plan}]}));});if(!data.items?.[0]?.selling_plan_allocation)throw new Error();window.location.assign(base+'checkout');}catch(err){error.textContent=root.querySelector('[data-checkout-error]').textContent;error.hidden=false;button.innerHTML=label;root.querySelectorAll('.ar-buy button').forEach(b=>b.disabled=b.dataset.wasDisabled==='1');busy=false;}}));}init();document.addEventListener('shopify:section:load',init);})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sw-wohlfuehlsets"] && !Shopify.designMode) return;
  try {
    

(() => {
  const instances = new WeakSet();
  function init(root) {
    if (!root || instances.has(root)) return;
    instances.add(root);
    const choices = [...root.querySelectorAll('[data-sw-bundle-choice]')];
    const chooseBundle = key => {
      if (!choices.some(choice => choice.dataset.swBundleChoice === key)) return;
      root.dataset.swBundleSelection = key;
      choices.forEach(choice => choice.setAttribute('aria-pressed', String(choice.dataset.swBundleChoice === key)));
    };
    choices.forEach(choice => choice.addEventListener('click', () => chooseBundle(choice.dataset.swBundleChoice)));
    if (choices.length) chooseBundle('trio');
    const mobileQuery = window.matchMedia('(max-width: 600px)');
    const initiallyOpenFaqs = [...root.querySelectorAll('.faq-list details[open]')];
    const updateFaqLayout = () => initiallyOpenFaqs.forEach(details => { details.open = !mobileQuery.matches; });
    updateFaqLayout();
    mobileQuery.addEventListener('change', updateFaqLayout);
    root.addEventListener('sw:destroy', () => mobileQuery.removeEventListener('change', updateFaqLayout), {once:true});

    const navigateInsideSection = event => {
      if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      const link = event.target.closest?.('a[href^="#sw-"]');
      if (!link || !root.contains(link) || link.hasAttribute('download') || (link.target && link.target !== '_self')) return;
      const hash = link.getAttribute('href');
      if (!hash.startsWith(`#sw-${root.dataset.sectionId}-`)) return;
      let targetId;
      try { targetId = decodeURIComponent(hash.slice(1)); } catch { return; }
      const target = document.getElementById(targetId);
      if (!target || !root.contains(target)) return;
      event.preventDefault();
      event.stopPropagation();
      const details = target.closest('details');
      if (details && root.contains(details)) details.open = true;
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      target.scrollIntoView({behavior: reducedMotion ? 'instant' : 'smooth', block: 'start'});
      if (window.location.hash !== hash) window.history.pushState(null, '', hash);
    };
    root.addEventListener('click', navigateInsideSection, true);
    root.addEventListener('sw:destroy', () => root.removeEventListener('click', navigateInsideSection, true), {once:true});
    const tabs = [...root.querySelectorAll('[data-sw-product-tab]')];
    const select = (key, focus = false) => {
      tabs.forEach(tab => {
        const active = tab.dataset.swProductTab === key;
        tab.setAttribute('aria-selected', String(active));
        tab.tabIndex = active ? 0 : -1;
        if (active && focus) tab.focus();
      });
      root.querySelectorAll('[data-sw-product-panel]').forEach(panel => { panel.hidden = panel.dataset.swProductPanel !== key; });
    };
    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => select(tab.dataset.swProductTab));
      tab.addEventListener('keydown', event => {
        let next;
        if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
        if (event.key === 'ArrowLeft') next = (index - 1 + tabs.length) % tabs.length;
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = tabs.length - 1;
        if (next !== undefined) { event.preventDefault(); select(tabs[next].dataset.swProductTab, true); }
      });
    });
    root.querySelectorAll('[data-sw-bundle]').forEach(button => {
      button.disabled = button.dataset.swReady !== 'true';
    });
    const sticky = root.querySelector('[data-sw-sticky]');
    const hero = root.querySelector('.hero');
    if (sticky && hero && 'IntersectionObserver' in window) {
      const observer = new IntersectionObserver(entries => {
        const entry = entries[0];
        sticky.classList.toggle('visible', !entry.isIntersecting && entry.boundingClientRect.top < 0);
      });
      observer.observe(hero);
      root.addEventListener('sw:destroy', () => observer.disconnect(), {once:true});
    }
    root.addEventListener('shopify:block:select', event => {
      const panel = event.target.closest('[data-sw-product-panel]');
      if (panel) select(panel.dataset.swProductPanel);
    });
  }
  const start = () => document.querySelectorAll('[data-sw-landing]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once:true}); else start();
  document.addEventListener('shopify:section:load', event => init(event.target.querySelector('[data-sw-landing]')));
  document.addEventListener('shopify:section:unload', event => event.target.querySelector('[data-sw-landing]')?.dispatchEvent(new Event('sw:destroy')));
})();

(() => {
  if (window.swWohlfuehlCartBound) return;
  window.swWohlfuehlCartBound = true;
  const activeRoots = new Map();
  const release = (root) => {
    (activeRoots.get(root) || []).forEach(({el, disabled}) => { el.disabled = disabled; el.removeAttribute('aria-busy'); });
    activeRoots.delete(root);
  };
  window.addEventListener('pageshow', (event) => {
    if (event.persisted) [...activeRoots.keys()].forEach(release);
  });

  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-sw-bundle]');
    const root = button && button.closest('[data-sw-landing]');
    if (!root || button.disabled || activeRoots.has(root)) return;
    event.preventDefault();
    const configElement = root.querySelector('[data-sw-config]');
    const status = root.querySelector('[data-sw-cart-status]');
    if (!configElement || !status) return;
    let config;
    try { config = JSON.parse(configElement.textContent); } catch { return; }
    const bundle = config.bundles[button.dataset.swBundle];
    const showMessage = (message, error = false) => {
      status.hidden = false;
      status.textContent = message;
      status.classList.toggle('is-error', error);
      status.setAttribute('tabindex', '-1');
      if (error) status.focus({preventScroll: false});
    };
    if (!bundle || !bundle.available || !Number.isSafeInteger(Number(bundle.variantId)) || Number(bundle.variantId) < 1) {
      showMessage(config.messages.unavailable, true);
      return;
    }
    const buttons = [...root.querySelectorAll('[data-sw-bundle]')];
    const previous = buttons.map(el => ({el, disabled: el.disabled}));
    activeRoots.set(root, previous);
    buttons.forEach(el => { el.disabled = true; el.setAttribute('aria-busy', 'true'); });
    showMessage(config.messages.adding);
    let added = false;
    let uncertain = false;
    let verifiedCartUrl;
    try {
      const addUrl = new URL(config.cartAddUrl, window.location.origin);
      const cartUrl = new URL(config.cartUrl, window.location.origin);
      if (addUrl.origin !== window.location.origin || cartUrl.origin !== window.location.origin) throw new Error();
      verifiedCartUrl = cartUrl.href;
      uncertain = true;
      const response = await fetch(addUrl.href, {
        method: 'POST',
        credentials: 'same-origin',
        headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
        body: JSON.stringify({items: [{id: Number(bundle.variantId), quantity: 1}]})
      });
      if (!response.ok) {
        uncertain = false;
        const result = await response.json().catch(() => ({}));
        showMessage(typeof result.description === 'string' ? result.description : config.messages.error, true);
        return;
      }
      added = true;
      const addedItem = await response.json().catch(() => ({}));
      showMessage(config.messages.added);
      // Open the drawer explicitly: other storefront scripts can replace the fetch hook.
      if (!window.__swATCHooked) {
        const addedEvent = new CustomEvent('sw:product:added', {detail: addedItem, cancelable: true, bubbles: true});
        document.dispatchEvent(addedEvent);
      }
      document.dispatchEvent(new CustomEvent('cart:open-drawer'));
      status.hidden = true;
    } catch {
      showMessage(config.messages.error, true);
      if (verifiedCartUrl) {
        const review = document.createElement('a');
        review.href = verifiedCartUrl;
        review.textContent = config.messages.reviewCart || 'Warenkorb prüfen';
        status.append(document.createTextNode(' '), review);
      }
      buttons.forEach(el => el.removeAttribute('aria-busy'));
    } finally {
      if (added || !uncertain) {
        release(root);
      }
    }
  });
})();


  } catch(e) { console.error(e); }
})();
})();
